import { Component,
  Input,
  ViewChild,
  ElementRef,
  forwardRef,
  OnInit,
  HostListener
} from '@angular/core';

import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';


@Component({
  selector: 'app-select-loading',
  templateUrl: './select-loading.component.html',
  styleUrls: ['./select-loading.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectLoadingComponent),
      multi: true
    }
  ]
})
export class SelectLoadingComponent implements ControlValueAccessor, OnInit {
  @Input() pageSize = 20;
  @Input() loadData!: (page: number, pageSize: number) => Promise<{ items: any[]; done: boolean }>;

  @ViewChild('scrollBox') scrollBox!: ElementRef;

  options: any[] = [];
  selected: any = null;
  selectedValue: string = '';
  currentPage = 0;
  loading = false;
  allLoaded = false;
  dropdownOpen = false;

  private onChange = (val: any) => {};
  private onTouched = () => {};

  constructor(private eRef: ElementRef){}

  ngOnInit() {
    this.loadNextPage().then(() => {
      this.selected = this.options.find((o) => o.value === this.selectedValue) || this.options[0];
    });
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectOption(option: any) {
    this.selected = option;
    this.onChange(option.value);
    this.onTouched();
    this.dropdownOpen = false;
  }

  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onScroll(event: any) {
    const el = event.target;
    const atBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 10;
    if (atBottom && !this.loading && !this.allLoaded) {
      this.loadNextPage();
    }
  }

  async loadNextPage() {
    if (!this.loadData || this.loading || this.allLoaded) return;

    this.loading = true;
    try {
      const result = await this.loadData(this.currentPage, this.pageSize);
      this.options = this.options.concat(result.items);
      this.allLoaded = result.done;
      if (!result.done) this.currentPage++;
    } catch (e) {
      console.error('Error loading data', e);
    }
    this.loading = false;
  }

  @HostListener('document:click', ['$event'])
    clickOutside(event: Event) {
      if (!this.eRef.nativeElement.contains(event.target)) {
        this.dropdownOpen = false;
      }
    }
}
